import { AutoFocusPlugin } from '@lexical/react/LexicalAutoFocusPlugin';
import { LexicalComposer } from '@lexical/react/LexicalComposer';
import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import { LexicalErrorBoundary } from '@lexical/react/LexicalErrorBoundary';
import { LinkPlugin } from '@lexical/react/LexicalLinkPlugin';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import { LexicalEditor } from 'lexical';
import React, { forwardRef } from 'react';
import { lexicalReferencesEditorConfig } from '../editors/LexicalReferencesEditor';
import { LexicalOnChange } from '../hooks/useLexicalReferencesEditor';
import { BasePropsPlugin } from '../Plugins/BasePropsPlugin';
import { BlurControlPlugin } from '../Plugins/BlurControlPlugin';
import { EditModeProviderPlugin } from '../Plugins/EditModeContextPlugin';
import { EditorRefPlugin } from '../Plugins/EditorRefPlugin';
import { HtmlContentPlugin } from '../Plugins/HtmlContentPlugin';
import { LinkNodePlugin } from '../Plugins/LinkNodePlugin';
import { PastePlugin } from '../Plugins/PastePlugin';
import { ReferencesFontPlugin } from '../Plugins/ReferencesFontPlugin';
import { TextContentPlugin } from '../Plugins/TextContentPlugin';

type Props = {
  onChange: LexicalOnChange;
  editMode: boolean;
  html?: string;
};

export const LexicalReferencesEditor = forwardRef<LexicalEditor, Props>((props, ref) => {
  const {
    editMode,
    onChange,
    html,
  } = props;

  return (
    <LexicalComposer initialConfig={lexicalReferencesEditorConfig}>
      <EditModeProviderPlugin editMode={editMode}>
        <div className='editor-container' style={{ height: '100%' }}>
          <RichTextPlugin
            contentEditable={<ContentEditable style={{ height: '100%' }} className="editor-input" data-testid="editor-input" />}
            ErrorBoundary={LexicalErrorBoundary}
          />
          <AutoFocusPlugin />
          <LinkPlugin />
          <EditorRefPlugin ref={ref} />
          <BasePropsPlugin onChange={onChange.baseProps} />
          <ReferencesFontPlugin
            onChange={onChange.font}
          />
          <TextContentPlugin onChange={onChange.textContent} />
          <LinkNodePlugin onChange={onChange.link} />
          <HtmlContentPlugin html={html} />
          <BlurControlPlugin/>
          <PastePlugin/>
        </div>
      </EditModeProviderPlugin>
    </LexicalComposer>
  );
});
